import { Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { OnboardingCard, ToggleMenuGroup } from '@hero/molecules';
import {
  AutomationReviewContactsAccordion,
  AutomationReviewExperienceAccordion,
  AutomationReviewGiftsAccordion,
  AutomationReviewOverviewAccordion
} from '@hero/organisms';
import { useOnboardingStore } from '@hero/store/hooks';

export default function ToggleMenu({ refetchAutomation }) {
  const { t } = useTranslation();
  const { automation: onboardingAutomation } = useOnboardingStore();
  const [defaultActiveMenus, setDefaultActiveMenus] = useState(['overview']);
  const [isOnboardingCardGift, setIsOnboardingCardGift] = useState(false);
  const [isOnboardingCardRecipient, setIsOnboardingCardRecipient] = useState(false);
  const [isOnboardingCardExperience, setIsOnboardingCardExperience] = useState(false);

  const giftTitleLabel = (
    <>
      <Typography variant="body1Bold">{t('gifts')}</Typography>
      <OnboardingCard
        styles={{
          wrapper: {
            right: 12,
            top: -12
          }
        }}
        position="right-start"
        cardOffset={[12, 12]}
        isCardShown={isOnboardingCardGift}
        setIsCardShown={setIsOnboardingCardGift}
        title={t('typeNameDetails', { name: t('gift') })}
        description={t('giftDetailsOnboardingCardDesc', { feature: t('automation') })}
        isInfoActive={onboardingAutomation?.infoCardsActive}
        featureType="automation"
        onTourButtonClick={() => {
          setIsOnboardingCardRecipient(true);
          setDefaultActiveMenus(['recipients']);
        }}
      />
    </>
  );

  const contactTitleLabel = (
    <>
      <Typography variant="body1Bold">{t('recipients')}</Typography>
      <OnboardingCard
        styles={{
          wrapper: {
            right: 12,
            top: -12
          }
        }}
        position="right-start"
        cardOffset={[12, 12]}
        isCardShown={isOnboardingCardRecipient}
        setIsCardShown={setIsOnboardingCardRecipient}
        title={t('typeNameDetails', { name: t('recipient') })}
        description={`${t('reviewBeforeActivating')}:`}
        isInfoActive={onboardingAutomation?.infoCardsActive}
        featureType="automation"
        onTourButtonClick={() => {
          setIsOnboardingCardExperience(true);
          setDefaultActiveMenus(['experience']);
        }}
      />
    </>
  );

  const experienceTitleLabel = (
    <>
      <Typography variant="body1Bold">{t('experience')}</Typography>
      <OnboardingCard
        styles={{
          wrapper: {
            right: 12,
            top: -12
          }
        }}
        position="right-start"
        cardOffset={[12, 12]}
        isCardShown={isOnboardingCardExperience}
        setIsCardShown={setIsOnboardingCardExperience}
        title={t('recipientExperience')}
        description={t('recipientExperienceOnboardingCardDesc')}
        isInfoActive={onboardingAutomation?.infoCardsActive}
        featureType="automation"
      />
    </>
  );

  const toggleList = [
    {
      id: 'overview',
      icon: <Icon name="order" color="var(--color-accent-primary-default)" />,
      title: <Typography variant="body1Bold">{t('overview')}</Typography>,
      children: () => (
        <AutomationReviewOverviewAccordion
          onClickOnboardingInfoCard={() => {
            setIsOnboardingCardGift(true);
            setDefaultActiveMenus(['gifts']);
          }}
        />
      )
    },
    {
      id: 'gifts',
      icon: <Icon name="gift-box" color="var(--color-accent-primary-default)" />,
      title: giftTitleLabel,
      children: () => <AutomationReviewGiftsAccordion refetchAutomation={refetchAutomation} />,
      TopContent: `${t('reviewBeforeActivating')}:`
    },
    {
      id: 'contacts',
      icon: <Icon name="contacts" color="var(--color-accent-primary-default)" />,
      title: contactTitleLabel,
      children: AutomationReviewContactsAccordion
    },
    {
      id: 'experience',
      icon: <Icon name="smartphone" color="var(--color-accent-primary-default)" />,
      title: experienceTitleLabel,
      children: AutomationReviewExperienceAccordion
    }
  ];

  return (
    <ToggleMenuGroup multiMenuActive list={toggleList} defaultActiveMenus={defaultActiveMenus} />
  );
}

ToggleMenu.propTypes = {
  refetchAutomation: PropTypes.func
};
